import styled from 'styled-components';

const ErrorContainer = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: #fff;
`;

const ErrorImage = styled.img`
  width: 80%;
  height: 80%;
  object-fit: contain;
`;

const ErrorImageAttribute = styled.a`
  width: 100%;
  text-align: center;
  color: #000;
  font-size: 8px;
`;

const ErrorPage = () => {
  return (
    <ErrorContainer>
      <ErrorImage src="/404_image.jpg" alt="error" />
      <ErrorImageAttribute href="https://www.freepik.com/free-vector/oops-404-error-with-broken-robot-concept-illustration_13315300.htm#query=404&position=0&from_view=keyword">
        Image by storyset on Freepik
      </ErrorImageAttribute>
    </ErrorContainer>
  );
};

export default ErrorPage;
